export default function Footer() {
  return (
    <footer className="bg-[#0f2044] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Brand */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#2563eb] rounded-md flex items-center justify-center">
              <span className="text-white font-black text-xs">ZB</span>
            </div>
            <span className="font-bold text-xl tracking-tight text-white">ZB Advisor</span>
          </div>

          {/* Social */}
          <div className="flex items-center gap-3">
            {["ri-instagram-line", "ri-linkedin-box-line", "ri-twitter-x-line", "ri-youtube-line"].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-[#2563eb] hover:text-[#2563eb] transition-colors cursor-pointer"
              >
                <i className={icon} />
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} ZB Advisor. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 hover:text-white/70 text-sm transition-colors cursor-pointer">Privacidade</a>
            <a href="#" className="text-white/40 hover:text-white/70 text-sm transition-colors cursor-pointer">Termos</a>
            <a href="#" className="text-white/40 hover:text-white/70 text-sm transition-colors cursor-pointer">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
